import { handleResponse, handleError } from "./apiUtils";
import * as apiConfig from "./config";
const baseUrl = `${apiConfig.API_URL}identity/`;
//const baseUrl = "https://localhost:44356/identity/"; //process.env.API_URL + "/routes/";

export function login(credentials) {
    return fetch(baseUrl + "login", { method: "POST", body: JSON.stringify(credentials), headers: { "content-type": "application/json" }, credentials: "include"})
        .then(handleResponse)
        .catch(handleError);
}

export function checkUserLogin() {
    return fetch(baseUrl + "checklogin", { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function logout() {
    return fetch(baseUrl + "logout", { method: "POST", headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function recoverUsername(recoveryEmail) {
    var email = { email: recoveryEmail };
    return fetch(baseUrl + "recoverusername", { method: "POST", body: JSON.stringify(email), headers: { "content-type": "application/json" } })
        .then(handleResponse)
        .catch(handleError);
}

export function requestPasswordReset(recoveryEmail) {
    var email = { email: recoveryEmail };
    return fetch(baseUrl + "generatepasswordreset", { method: "POST", body: JSON.stringify(email), headers: { "content-type": "application/json" } })
        .then(handleResponse)
        .catch(handleError);
}


export function resetPassword(reset) {
    return fetch(baseUrl + "resetpasswordwithcode", { method: "POST", body: JSON.stringify(reset), headers: { "content-type": "application/json" } })
        .then(handleResponse)
        .catch(handleError);
}

export function changePassword(reset) {
    return fetch(baseUrl + "changepassword", { method: "PUT", body: JSON.stringify(reset), headers: { "content-type": "application/json" }, credentials: "include" })
        .then(handleResponse)
        .catch(handleError);
}

export function registerUser(user) {
    return fetch(baseUrl + "register", { method: "POST", body: JSON.stringify(user), headers: { "content-type": "application/json" } })
        .then(handleResponse)
        .catch(handleError);
}

export function activateAcount(activationCode) {
    return fetch(baseUrl + "activateaccount", { method: "POST", body: JSON.stringify(activationCode), headers: { "content-type": "application/json" } })
        .then(handleResponse)
        .catch(handleError);
}


// WEBPACK FOOTER //
// ./src/api/authApi.js